import axios from 'axios'
import moment from 'moment'

import { useLocalStorage } from '../hooks/useLocalStorage'

const API_URL =
  process.env.REACT_APP_API_URL || 'https://dm.aibuddyassistant.com/api'

export const useAuth = () => {
  const { getStorage, persistStorage, clearStorage } = useLocalStorage()

  // Migrate legacy magnunToken to cloveraiToken
  if (
    localStorage.getItem('magnunToken') &&
    !localStorage.getItem('cloveraiToken')
  ) {
    localStorage.setItem('cloveraiToken', localStorage.getItem('magnunToken'))
    localStorage.removeItem('magnunToken')
  }

  const auth = () => {
    const token = localStorage.getItem('token')
    const storage = getStorage('cloveraiToken')

    // Check JWT token first
    if (token) return true

    // Fallback to legacy token
    if (!storage) return false
    const now = moment().valueOf()
    if (now > storage?.expires) return false

    return true
  }

  const login = async (email, password) => {
    try {
      // Try backend API login first
      const response = await axios.post(`${API_URL}/auth/login`, {
        email,
        password,
      })

      if (response.data.token) {
        // Store JWT token
        localStorage.setItem('token', response.data.token)
        localStorage.setItem('user', JSON.stringify(response.data.user))

        // Also store legacy token for compatibility
        const { host, protocol } = window.location
        persistStorage('cloveraiToken', {
          expires: moment().add(7, 'days').valueOf(),
          host: `${protocol}//${host}`,
          value: response.data.token,
        })

        return true
      }
    } catch (error) {
      console.error('API login failed:', error)
    }

    return false
  }

  const logout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    clearStorage('cloveraiToken')

    return true
  }

  return { auth, login, logout }
}
